module.exports = __webpack_public_path__ + "static/media/icecream.86bc1168.jpg";